import { render, staticRenderFns } from "./VRKPIDetails.vue?vue&type=template&id=24c3fe9d"
import script from "./VRKPIDetails.vue?vue&type=script&lang=js"
export * from "./VRKPIDetails.vue?vue&type=script&lang=js"
import style0 from "./VRKPIDetails.vue?vue&type=style&index=0&id=24c3fe9d&prod&scope=true&lang=css"
import style1 from "./VRKPIDetails.vue?vue&type=style&index=1&id=24c3fe9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports